import React, { Fragment, useEffect } from 'react';
import Greeting from './Greeting';
import TaxYearBar from './TaxYearBar';
import CreateNewReturnSection from './CreateNewReturnSection';
import './Dashboard.css';
import TaxYearWorkflow from './TaxYearWorkflow';
import { useDispatch, useSelector } from 'react-redux';
import LayoutActions from '../../../../../reducers/layoutRedux';

const Dashboard = (props) => {
    const { layoutType } = props;

    const dispatch = useDispatch();
    const taxYears = useSelector(state => state.workflow.case_state.taxYears);
    const caseState = useSelector(state => state.workflow.case_state);
    const taxYearTab = useSelector(state => state.layout.taxYearTab);
    const currentTaxYear = useSelector(state => state.layout.currentTaxYear);
    
    useEffect(() => {
        if ((taxYears.length == 1) || (!taxYearTab && taxYears.length > 0)) {
            var selectedTaxYearTab = taxYears[0]?.taxYear;
            dispatch(LayoutActions.setTaxYearTab(selectedTaxYearTab));
        }
    }, [taxYears, taxYearTab, dispatch]);

    const selectedTaxYear = useSelector(state => state.layout.taxYearTab);
    const selectedTaxYearState = taxYears.find(ty => ty.taxYear === selectedTaxYear);

    const interviewState = useSelector(state => state.interview || {});

    const hasInterviewPageData = (taxYear) => {
        const interview = interviewState[taxYear]?.interview;

        if (!interview) return false;

        const checkForData = (data) => {
            if (!data) return false;

            if (typeof data === 'object') {
                const keys = Object.keys(data);
                const hasNonEmptyData = keys.some(key => {
                    const value = data[key];
                    if (typeof value === 'object' && value !== null) {
                        return Object.keys(value).length > 0;
                    }
                    return value !== '' && value !== null && value !== undefined;
                });
                return hasNonEmptyData;
            }

            return false;
        };

        const hasData = checkForData(interview);

        return hasData;
    };

    const isInterviewStarting = (taxState) => {
        const isOnPageOne = taxState?.interview_state?.current_page === '1';
        const noCompletedDate = taxState?.interview_state?.completed_date === null;
        const notComplete = !taxState?.interview_state?.complete;
        const hasPageData = hasInterviewPageData(taxState.taxYear);
        return isOnPageOne && noCompletedDate && notComplete && !hasPageData;
    };

    const showFirstTimeCreateNewReturnSection = taxYears.length == 1 &&
        selectedTaxYearState &&
        isInterviewStarting(selectedTaxYearState) &&
        (
            (selectedTaxYearState.assigned_tax_pro === null && !selectedTaxYearState.is_direct) ||
            selectedTaxYearState.is_direct
        );

    const showCreateNewReturnSection = !showFirstTimeCreateNewReturnSection && (() => {
        for (let i = currentTaxYear; i > currentTaxYear - 4; i--) {
            if (!taxYears.some(ty => ty.taxYear === i)) {
                return true;
            }
        }
        return false;
    })();

    return (
        <Fragment>
            <Greeting showCreateNewReturn={showCreateNewReturnSection} layoutType={layoutType} />
            <TaxYearBar taxStates={taxYears} showTaxYears={!showFirstTimeCreateNewReturnSection} layoutType={layoutType} />
            {showFirstTimeCreateNewReturnSection && <CreateNewReturnSection layoutType={layoutType} />}
            {!showFirstTimeCreateNewReturnSection && taxYears.map(x => <TaxYearWorkflow key={x.taxYear} taxState={x} caseState={caseState} />)}
        </Fragment>
    )
}

export default Dashboard